var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',_vm._b({attrs:{"options":_vm.options,"change-on-select":"","props":_vm.props,"separator":"/","clearable":""},on:{"change":_vm.handleItemChange}},'el-cascader',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }